import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, firstValueFrom } from 'rxjs';
import { ExecutiveDashboardVisibilityService } from 'src/app/pages/dashboard/dashboard-executive/services/executive-dashboard-visibility.service';
import { DemoService } from 'src/app/services/demo/demo.service';
import { shouldBypassExecutiveDashboardUpsell } from 'src/app/services/demo/demo-mock-data-visibility';
import { GrowthBookService } from 'src/app/services/growthbook/service';

/**
 * Redirects to /upgrade/dashboard-executive when the executive dashboard
 * upsell should be shown (flag enabled + no dashboard access + CTA conditions met).
 */
export const executiveDashboardUpsellGuard: CanActivateFn = async () => {
  const growthbook = inject(GrowthBookService);
  const visibilityService = inject(ExecutiveDashboardVisibilityService);
  const demoService = inject(DemoService);
  const router = inject(Router);

  await firstValueFrom(growthbook.initialized.pipe(filter(x => x)));

  const showExecutiveDemoData = await firstValueFrom(
    demoService.showExecutiveDemoData$.pipe(filter((value): value is boolean => value !== undefined)),
  );
  if (shouldBypassExecutiveDashboardUpsell(showExecutiveDemoData)) {
    return true;
  }

  const upgradeCtas = await firstValueFrom(visibilityService.upgradeCtas$);
  if (upgradeCtas.premiumUnder20) {
    return router.createUrlTree(['/invite', 'dashboard-executive']);
  }

  const showUpsell = await firstValueFrom(visibilityService.showUpsell$);
  if (showUpsell) {
    return router.createUrlTree(['/upgrade', 'dashboard-executive']);
  }

  return true;
};
